import './Drawcanvas.css';
import { useSelector } from 'react-redux';

function NewGame(props) {

  const ps = useSelector((state) => state.playerState );
  const socket = props.socket;

  function newGame(e) {
    e.preventDefault();
    socket.emit("newGame");
  }

  return (
    <div>
      <p>New Game?</p>
      <form onSubmit={newGame} className="w-full max-w-lg">
      <button disabled={!(ps.host)} onClick={(evt) => newGame(evt)} type="Submit" className={((!ps.host) ? 'disabled:opacity-50 ' : '') + "m-3 bg-green-500 hover:bg-green-700 font-bold py-2 px-4 rounded"}>Back to Lobby</button>
      </form>
    </div>
  );
}

export default NewGame;
